@if (isLoadingSubject | async) {
  <div class="app-loader-wrapper">
    <div class="centered">
      <span class="spin"></span>
      <p>Loading...</p>
    </div>
  </div>
} @else {
  <router-outlet></router-outlet>
}
